// Copyright 2026 Hardfin, Inc.
import { z } from 'zod';

/**
 * Status values for a fulfillment order line item.
 * Maps to the backend's FulfillmentOrderLineItemStatus enum.
 *
 * This is a GENERATED column computed from quantities — it cannot produce
 * CANCELLED (that is an order-level concept only).
 */
export const fulfillmentOrderLineItemStatusSchema = z.enum([
  'DRAFT',
  'OPEN_FULL',
  'OPEN_PARTIAL',
  'OPEN_OVERAGE',
  'SHIPPED_FULL',
  'SHIPPED_PARTIAL',
  'SHIPPED_OVERAGE',
  'DELIVERED_FULL',
  'DELIVERED_PARTIAL',
  'DELIVERED_OVERAGE',
]);

export type FulfillmentOrderLineItemStatus = z.infer<
  typeof fulfillmentOrderLineItemStatusSchema
>;
